import { render, staticRenderFns } from "./viewPedidos.vue?vue&type=template&id=04f39669&scoped=true&"
import script from "./viewPedidos.vue?vue&type=script&lang=js&"
export * from "./viewPedidos.vue?vue&type=script&lang=js&"
import style0 from "./viewPedidos.vue?vue&type=style&index=0&id=04f39669&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f39669",
  null
  
)

export default component.exports